import { render, staticRenderFns } from "./ShowFileModal.vue?vue&type=template&id=6045df57&"
import script from "./ShowFileModal.vue?vue&type=script&lang=js&"
export * from "./ShowFileModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowFileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports